module.exports = __webpack_public_path__ + "static/new_ip-2-442c720bd173018b195c0946ebd2b6ad.svg";